export default "__VITE_ASSET__08f428f3__"